<template>
  <div id="changePhoneDialog">
    <el-dialog
      :visible.sync="dialogVisible"
    >
      <p class="pwdTitle">更换手机号码</p>
      <div class="inputWrap">
        <QrDialog
          ref="qrDialog"
          title="重置手机号码二维码"
          :url="url"
          content="请使用手机扫码进行更换手机号码"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global http protocol*/
import QrDialog from './qrDialog.vue'
export default {
  components: {
    QrDialog
  },
  data() {
    return {
      tel: localStorage.getItem('myPhone'),
      dialogVisible: false,
      url: '',
      baseUrl: window.g.APP_PATH_mobile
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
      this.queryQuantity()
    },
    // 得到秘钥 --- 视频没有超过五次
    getSessionKey() {
      http
        .getRes(protocol.param_getSessionKey)
        .then(response => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
        })
    },
    // 得到秘钥 --- 视频超过五次 进入人工审核
    getSessionKey1() {
      http
        .getRes(protocol.param_getSessionKey1)
        .then(response => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
        })
    },
    // 查询录制次数 --- 具体跳转到哪个页面
    queryQuantity() {
      protocol.param_authnVideoQuantity.param.typeId = 3 // 3 更换手机号
      http
        .postFront(protocol.param_authnVideoQuantity)
        .then(response => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            if (value < 5) {
              // 视频没有超过五次
              this.getSessionKey()
            } else {
              // 视频认证超过五次进入人工审核
              this.getSessionKey1()
            }
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#changePhoneDialog {
  /deep/ .el-dialog {
    padding: 109px 0 199px;
    width: 1006px;
    // height: 708px;
    background-color: #F1F1F1 !important;
    border-radius: 8px;
    text-align: center;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
          color: #909399;
      }
    }
    .el-dialog__body {
      padding: 0;
    }
    .pwdTitle {
      font-size: 24px;
    }
    .inputWrap {
      img {
        width: 270px;
        height: 270px;
        margin:  49px auto 37px;
      }
    }
  }
}
</style>
